import { render, staticRenderFns } from "./ICICI.vue?vue&type=template&id=55614376&scoped=true&"
import script from "./ICICI.vue?vue&type=script&lang=js&"
export * from "./ICICI.vue?vue&type=script&lang=js&"
import style0 from "./ICICI.vue?vue&type=style&index=0&id=55614376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55614376",
  null
  
)

export default component.exports